module.exports = __webpack_public_path__ + "static/media/LedMatrix.1bbbbff4.gif";